import * as React from "react";

import { useState, useEffect } from "react";
import cx from "classnames";
import { Link, useHistory } from "react-router-dom";
import { v4 } from "uuid";

// icons and logos
import logo from "../../../../assets/images/logo.jpeg";
import CloseIcon from "@material-ui/icons/Close";

// sidebar content
import { navItems } from "../../../../config/navItems";

// styles
import styles from "./SideBar.module.scss";
import StatusButton from "../StatusButton/StatusButton";

//redux
import { useDispatch, useSelector } from "react-redux";
import { getStatus, setStatus } from "../../../../redux/actions/store/status";
import { IBaseModel } from "../../../../interfaces/base";
import { API_INTEGRATION_ID } from "../../../../config";

import { IPartnerStoreRequestModel } from "../../../../interfaces/store";
import { uberStoreStatusCodes } from "../../../../config/uberStoreStatusCodes";
import StatusPopup from "../StatusPopup/StatusPopup";
import { SET_STATUS_RESET } from "../../../../redux/actions/types";
import ConformationPopup from "../ConformationPopup/ConformationPopup";
import { Spinner } from "reactstrap";
import { getMenuList } from "../../../../redux/actions/menu/menuActions";
import { spawn } from "child_process";
import { IStorePartner } from "../../../../interfaces/configuration";
import apis from "../../../../api/apis";

import { Button } from "@mui/material";
import { IPartnerMenuItemRequestModel } from "../../../../interfaces/menu";
import { APIResponseType } from "../../../../config/enumApiResponseTypes";
import LoadingComponent from "../../../loadingComponent/LoadingComponent";

interface IProps {
  toggleSidebar: () => void;
  expanded: boolean;
}

const SideBar: React.FC<IProps> = ({ toggleSidebar, expanded }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showconformation, setShowconformation] = useState(false);
  const [reason, setReason] = useState("");
  const [pauseUntil, setPauseUntil] = useState("");
  const [timeValidator, setTimeValidator] = useState(false);
  const [reasonValidator, setReasonValidator] = useState(false);

  const [partnerList, setPartnerList] = useState<IStorePartner[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  //console.log(partnerList);

  const history = useHistory();
  const dispatch = useDispatch();

  const { loading, status } = useSelector(
    (state: any) => state.getStoreStatusReducer
  );
  // console.log("current status");
  // console.log(status);

  const store = useSelector((state: any) => state.setStoreStatusReducer);
  const { user } = useSelector((state: any) => state.authentication);
  //const auth = useSelector((state: any) => state.authentication);

  //console.log(auth);
  const getPartnerStoreList = async () => {
    try {
      // setIsLoading(true);
      const requestModel: IBaseModel = {
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };
      const response = await apis.configuration.getStorePartners(requestModel);

      setPartnerList(response.ResponseData.Storepartners);

      //setIsLoading(false);
    } catch (error) {
      console.log(error);
      //setIsLoading(false);
    }
  };

  useEffect(() => {
    getPartnerStoreList();
  }, []);

  useEffect(() => {}, []);

  useEffect(() => {
    const data: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };

    //console.log("before")
    dispatch(getStatus(data));
    //console.log("After")
    if (store.isUpdated) {
      history.push("/BLXOrderHub/orders");
      dispatch({ type: SET_STATUS_RESET });
    }
  }, [
    dispatch,
    history,
    store.isUpdated,
    user?.CompanyKey,
    user?.LocationKey,
    user?.UserKey,
    user?.EnvironmentName,
  ]);

  const storeStatusHandler = async () => {
    if (status.StoreStatusCode === "PAUSED") {
      // console.log("resume store");
      setShowconformation(true);
    } else {
      setShowPopup(true);
    }
  };

  const submitResume = () => {
    let resume: IPartnerStoreRequestModel = {
      StoreStatusCode: uberStoreStatusCodes.storeOnline,
      StorePausedUntilTime: "",
      StorePauseReason: "",
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };
    dispatch(setStatus(resume));
    setShowconformation(false);
  };

  //close popup
  const handleClosePopup = () => {
    setPauseUntil("");
    setReason("");
    setShowPopup(false);
    setTimeValidator(false);
    setReasonValidator(false);
  };

  //pause store
  const pauseStore = () => {
    //console.log("pause clicked");
    let pause: IPartnerStoreRequestModel = {
      StoreStatusCode: uberStoreStatusCodes.storePaused,
      StorePausedUntilTime: pauseUntil,
      StorePauseReason: reason,
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };
    dispatch(setStatus(pause));
    setShowPopup(false);
  };

  //time and reason
  const timeHandler = (e: any) => {
    //console.log(newDateObj.toISOString());
    if (e.target.value === "60") {
      setPauseUntil("");
      //console.log("60");
      // console.log(pauseUntil);
    } else {
      //setting pause time
      var oldDateObj = new Date();
      var newDateObj = new Date();
      let minutesToAdd = e.target.value * 60 * 1000;
      newDateObj.setTime(oldDateObj.getTime() + minutesToAdd);

      setPauseUntil(newDateObj.toISOString());
    }

    setTimeValidator(true);
  };

  const reasonHandler = (e: any) => {
    //console.log(e.target.value);
    setReason(e.target.value);
    setReasonValidator(true);
  };

  const handleMenuSync = () => {
    const data: IBaseModel = {
      RequestId: API_INTEGRATION_ID,
      IntegrationId: API_INTEGRATION_ID,
      ApiKey: "",
      UID: {
        CompanyKey: user?.CompanyKey ?? 0,
        LocationKey: user?.LocationKey ?? 0,
        UserKey: user?.UserKey ?? 0,
        EnvironmentName: user?.EnvironmentName ?? 0,
        IsUrbanPiper: user?.IsUrbanPiper ?? false,
      },
      RequestingUser: 0,
      RequestingId: "",
      Schema: "",
      ValidationMessages: [],
      IsApprovedStatus: 0,
      IsActive: 0,
    };
    dispatch(getMenuList(data));
  };

  const syncShopifyMenu = async () => {
    try {
      setIsLoading(true);
      const data: IPartnerMenuItemRequestModel = {
        IsSpecialInstructionEnable: false,
        PartnerMenuItemList: [],
        FilteredMenuItemCount: 0,
        RequestId: API_INTEGRATION_ID,
        IntegrationId: API_INTEGRATION_ID,
        ApiKey: "",
        UID: {
          CompanyKey: user?.CompanyKey ?? 0,
          LocationKey: user?.LocationKey ?? 0,
          UserKey: user?.UserKey ?? 0,
          EnvironmentName: user?.EnvironmentName ?? 0,
          IsUrbanPiper: user?.IsUrbanPiper ?? false,
        },
        RequestingUser: 0,
        RequestingId: "",
        Schema: "",
        ValidationMessages: [],
        IsApprovedStatus: 0,
        IsActive: 0,
      };

      const response = await apis.Menus.syncShopifyMenu(data);

      if (response.ResponseType === APIResponseType.Success) {
        window.location.reload();
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  if (isLoading) {
    return <LoadingComponent />;
  }
  return (
    <div className={cx(styles.sidebar, expanded ? styles.show : styles.hide)}>
      <div className={styles.header}>
        <img src={logo} alt="Company Logo" className={styles.logo} />
        <CloseIcon
          className={styles.close_icon}
          onClick={toggleSidebar}
          fontSize="large"
        />
      </div>
      <div className={styles.content}>
        {navItems.map((item) => (
          <Link key={v4()} to={item.path} onClick={toggleSidebar}>
            {item.name}
          </Link>
        ))}
        {/* <Link to={"/reports"}>X-report</Link> */}
        {/* <Link key={v4()} to={"/sales"} onClick={toggleSidebar}>
          <span>Sales</span>
        </Link> */}

        {user !== undefined ? (
          user && user.IsUrbanPiper === true ? (
            <>
              <Link key={v4()} to={"/configuration"} onClick={toggleSidebar}>
                <span>Enable/Disable Store</span>
              </Link>
            </>
          ) : null
        ) : null}

        {/* sync menu button */}
        {partnerList.length > 0 && (
          <>
            {partnerList.map((partner: IStorePartner) =>
              partner.OrderTypeName === "Shopify" ? (
                <Button variant="contained" onClick={syncShopifyMenu}>
                  Sync Shopify Menu
                </Button>
              ) : null
            )}
          </>
        )}

        {/* {user !== undefined && user.IsUrbanPiper === true ? (
          <>
            <Link key={v4()} to={"/configuration"} onClick={toggleSidebar}>
              <span>Enable/Disable Store</span>
            </Link>
          </>
        ) : null} */}

        {/* store status button */}

        <div>
          {showconformation && (
            <>
              <ConformationPopup
                btnSubmit={submitResume}
                handleClose={() => setShowconformation(false)}
              />
            </>
          )}

          {showPopup && (
            <StatusPopup
              handleClose={handleClosePopup}
              btnSubmit={pauseStore}
              pauseDuration={pauseUntil}
              pauseReason={reason}
              reasonValidation={reasonValidator}
              timeValidation={timeValidator}
              timeContent={
                <>
                  <div className={styles.radio_button_container}>
                    <form>
                      <input
                        type="radio"
                        id="1"
                        name="radioFruit"
                        value={10}
                        onChange={timeHandler}
                      />
                      <label htmlFor="1">10 Minutes</label>

                      <input
                        type="radio"
                        id="2"
                        name="radioFruit"
                        value={20}
                        onChange={timeHandler}
                      />
                      <label htmlFor="2">20 Minutes</label>

                      <input
                        type="radio"
                        id="3"
                        name="radioFruit"
                        value={30}
                        onChange={timeHandler}
                      />
                      <label htmlFor="3">30 Minutes</label>

                      <input
                        type="radio"
                        id="4"
                        name="radioFruit"
                        value={60}
                        onChange={timeHandler}
                      />
                      <label htmlFor="4">Until further notice</label>
                    </form>
                  </div>
                </>
              }
              reasonContent={
                <>
                  <div>
                    <form>
                      <input
                        type="radio"
                        id="r1"
                        name="radioFruit"
                        value="No Food"
                        onChange={reasonHandler}
                      />
                      <label htmlFor="r1">No Food</label>

                      <input
                        type="radio"
                        id="r2"
                        name="radioFruit"
                        value="Out of menu"
                        onChange={reasonHandler}
                      />
                      <label htmlFor="r2">Out of menu</label>

                      <input
                        type="radio"
                        id="r3"
                        name="radioFruit"
                        value="Maintenance"
                        onChange={reasonHandler}
                      />
                      <label htmlFor="r3">Maintenance</label>

                      <input
                        type="radio"
                        id="r4"
                        name="radioFruit"
                        value="Other"
                        onChange={reasonHandler}
                      />
                      <label htmlFor="r4">Other</label>
                    </form>
                  </div>
                </>
              }
            />
          )}
        </div>
      </div>

      <div className={styles.btn_container}>
        {loading ? (
          <Spinner children="" type="grow" color="primary" />
        ) : status === undefined ||
          (status && status.StoreStatusCode === null) ||
          (status && status.StoreStatusCode === undefined) ||
          Object.entries(status).length === 0 ? (
          <p style={{ textAlign: "left" }}>Unable To Locate Store</p>
        ) : (
          <>
            <StatusButton
              storeState={status.StoreStatusCode}
              click={storeStatusHandler}
              title={
                status.StoreStatusCode === "PAUSED"
                  ? "Resume store"
                  : "Pause store"
              }
            />
          </>
        )}
      </div>

      {!loading && status.StoreStatusCode === "PAUSED" ? (
        <>
          <div className={styles.bottom_text}>
            <span>STORE IS PAUSED </span>
          </div>
        </>
      ) : (
        <>
          <div className={styles.bottom_text_online}>
            <span>ACCEPTING ORDERS </span>
          </div>
        </>
      )}
    </div>
  );
};

export default SideBar;
function state(
  state: any,
  arg1: (rootReducer: unknown) => any
): { authentication: any } {
  throw new Error("Function not implemented.");
}
